export const SkillsData = [
  {
    type : "Front-End",
    list : [
      {
        name : "ReactJS",
        icon : <i class="devicon-react-original colored"></i>
      },
      {
        name : "Redux",
        icon : <i class="devicon-redux-original colored"></i>
      },
      {
        name : "Javascript",
        icon : <i class="devicon-javascript-plain colored"></i>
      },
      {
        name : "HTML5",
        icon : <i class="devicon-html5-plain colored"></i>
      },
      {
        name : "Css3",
        icon : <i class="devicon-css3-plain colored"></i>
      },
      {
        name : "Bootstrap",
        icon : <i class="devicon-bootstrap-plain colored"></i>
      },
      {
        name : "Sass",
        icon : <i class="devicon-sass-original colored"></i>
      }
    ]
  }
]
